// ---------------------------------------------------------
// Datei: projektvorbereitung.ts
// Zweck: One360-API-Client für das Projektvorbereitung-Briefing (Ticket #928, erweitert #1055)
// Kontext: Ruft den Endpoint GET /api/v1/ops/projects/:id/projektvorbereitung-template über den
//          bestehenden /one360-Proxy auf — exaktes Muster von projektdokumentation.ts. Ticket
//          #1055 ergänzt PUT .../rohre-fittinge zum Speichern der Rohr-/Fitting-Freitextnotiz
//          (nur für Ops-Manager, siehe ProjektvorbereitungTemplate.isOpsManager).
// ---------------------------------------------------------

import one360 from './one360';
import type {
  ProjektvorbereitungDokumentUploadResult,
  ProjektvorbereitungTemplate,
} from '../../interfaces/projektvorbereitung';

export const getProjektvorbereitungTemplate = async (
  projectId: string
): Promise<ProjektvorbereitungTemplate> =>
  one360.get<ProjektvorbereitungTemplate>(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektvorbereitung-template`);

export interface RohrFittingNote {
  note?: string | null;
  updatedAtUtc?: string | null;
}

export const saveRohrFittingNote = async (
  projectId: string,
  note: string
): Promise<RohrFittingNote> =>
  one360.put<RohrFittingNote>(
    `/api/v1/ops/projects/${encodeURIComponent(projectId)}/rohre-fittinge`,
    { note }
  );

// Eigener Endpoint statt des allgemeinen Drive-Uploads: das Backend lässt diese vorab sichtbare
// Briefing-Ablage ausschließlich von Ops-Managern beschreiben (Ticket #1139).
export const uploadProjektvorbereitungDokument = async (
  projectId: string,
  dealName: string,
  file: File
): Promise<ProjektvorbereitungDokumentUploadResult> => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('DealName', dealName);
  return one360.post<ProjektvorbereitungDokumentUploadResult>(
    `/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektvorbereitung-documents`,
    formData,
    { timeout: 90_000 }
  );
};
